var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-5 border-right pr-md-4" },
        [
          _c("custom-drop-down", {
            attrs: {
              disabled: _vm.readOnly,
              fieldkey: "id",
              fieldname: "name",
              label: "Secciones",
              options: _vm.availableSections,
              placeholder: "Seleccione"
            },
            model: {
              value: _vm.current,
              callback: function($$v) {
                _vm.current = $$v
              },
              expression: "current"
            }
          }),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("action-button", {
                attrs: {
                  disabled: _vm.readOnly,
                  i: "fas fa-file-plus",
                  text: "Añadir",
                  variant: "success"
                },
                on: { click: _vm.add }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-7 pl-md-4 mt-3 mt-md-0" },
        [
          _c("custom-chips-group", {
            attrs: {
              disabled: _vm.readOnly,
              "no-background": "",
              "no-wrap": true,
              "object-text": "name",
              "on-item-deleted": _vm.remove,
              "selected-items": _vm.model,
              title: "Secciones Seleccionadas:"
            }
          }),
          _vm.showError && _vm.model.length < _vm.min
            ? _c("error", {
                attrs: {
                  message: "Debe añadir al menos una sección.",
                  variant: "no-border"
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }